var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomIn01 = function SvgZoomIn01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M8.782 4.973h2.147v3.774h3.838v2.212H10.93v3.772H8.782v-3.772H5.01V8.747h3.773Zm.857-2.789A7.55 7.55 0 0 0 5.4 3.607C1.952 6.079 1.171 10.893 3.578 14.34c2.472 3.383 7.286 4.228 10.734 1.69 3.383-2.471 4.228-7.22 1.756-10.667a7.74 7.74 0 0 0-6.429-3.18M9.782 0a9.87 9.87 0 0 1 8.043 4.128c2.797 3.968 2.342 9.237-.91 12.555l10.277 12.88c.261.326.13.846-.195 1.04l-1.626 1.237c-.39.26-.846.195-1.106-.13l-9.433-13.401c-4.358 2.602-10.018 1.43-13.01-2.732C-1.3 11.153-.325 5.039 4.1 1.85A9.73 9.73 0 0 1 9.782 0"
  }))));
};
export { SvgZoomIn01 as ReactComponent };
export default __webpack_public_path__ + "assets/Zoom In_01.03ff9500a16708c2701d9cb1261c0ec1.svg";